<template>
  <div
    style="    position: absolute;
    left: auto;
    right: 0px;
    display: flex;
    align-items: center;
    justify-content: center;"
  >
    <v-btn color="clear" icon small @click="$emit('printContent')">
      <v-icon>print</v-icon>
    </v-btn>
    <v-btn color="clear" icon>
      <download-csv class="btn btn-default" :data="items" :name="name">
        <v-icon>cloud_download</v-icon>
      </download-csv>
    </v-btn>
    <v-btn color="clear" icon small @click="$emit('close')">
      <v-icon>close</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    items: {
      default: function() {
        return [];
      }
    }
  }
};
</script>

<style></style>
